/**
 * @generated SignedSource<<3b024e3e66745bc367b1b1103c888dfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentWeeklySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportFromDate: any;
  reportToDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type AttemptsWithoutPassingQuery$variables = {
  filter: StudentSkillAssessmentWeeklySnapshotFilterInput;
};
export type AttemptsWithoutPassingQuery$data = {
  readonly studentsAttemptedSkillsWithoutPassing: ReadonlyArray<{
    readonly attempts: number;
    readonly student: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined;
  }>;
};
export type AttemptsWithoutPassingQuery = {
  response: AttemptsWithoutPassingQuery$data;
  variables: AttemptsWithoutPassingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentAttemptsWithoutPassing",
    "kind": "LinkedField",
    "name": "studentsAttemptedSkillsWithoutPassing",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Student",
        "kind": "LinkedField",
        "name": "student",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "attempts",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AttemptsWithoutPassingQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AttemptsWithoutPassingQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "baf135b22eb6ee5651c557f80a54d2db",
    "id": null,
    "metadata": {},
    "name": "AttemptsWithoutPassingQuery",
    "operationKind": "query",
    "text": "query AttemptsWithoutPassingQuery(\n  $filter: StudentSkillAssessmentWeeklySnapshotFilterInput!\n) {\n  studentsAttemptedSkillsWithoutPassing(filter: $filter) {\n    student {\n      id\n      firstName\n      lastName\n      publicUserId\n    }\n    attempts\n  }\n}\n"
  }
};
})();

(node as any).hash = "4091b89724b8cb2cffeb754450349e48";

export default node;
